export default __webpack_public_path__ + "static/media/p1.900e9b70.png";